export type PublicSiteDomain = "tashiraev.com" | "tashiraev.ae";

export function publicSiteDomain(host: string | null | undefined): PublicSiteDomain {
  const hostname = (host || "").trim().toLowerCase().split(":")[0].replace(/^www\./, "");
  return hostname === "tashiraev.ae" || hostname.endsWith(".tashiraev.ae") ? "tashiraev.ae" : "tashiraev.com";
}

export function publicSiteOrigin(domain: PublicSiteDomain) {
  return `https://${domain}`;
}
